import React, {
  Fragment,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import { MapPin } from "react-feather";
import { ProfilePictureRootURL } from "../../api";
import man from "../../assets/images/avtar/man.png";
import "../../style/custom-css/ProfilePopup.css";
import ContactRequestModal from "../Chat/NewChat/ContactRequestModal";

function ProfilePopup(props) {
  const tutorInfo = props.tutorInfo;
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const initilindex = { index: 0, isOpen: false, toggler: toggle };
  const [photoIndex, setPhotoIndex] = useState(initilindex);

  const handleStartConversationModal = (e, tuition) => {
    e.preventDefault();
    setPhotoIndex({
      ...photoIndex,
      isOpen: true,
      userId: tuition.studentId,
      name:
        tuition.student?.name?.firstName +
        " " +
        tuition.student?.name?.lastName,
      tuitions: tuition,
    });
    setModal(true);
  };
  const callback = useCallback((photo) => {
    setPhotoIndex(photo);
  });
  return (
    <div className="container">
      <div>
        <div className="" style={{ margin: "0 0 0 0" }}>
          <div className="px-2 card-photo">
            <img
              src={
                tutorInfo.media.picture
                  ? ` ${ProfilePictureRootURL + tutorInfo.media.picture}`
                  : man
              }
              alt="Profile Picture"
              width={"auto"}
              height={100}
            />
          </div>
          <div className="px-2 py-0 pt-1">
            <p className="mb-0 text-dark">
              {tutorInfo.name.firstName} {tutorInfo.name.lastName}
            </p>
            <div className="text-dark">
              <p className="mb-0" style={{ fontSize: "10px" }}>
                <MapPin style={{ height: "10px" }} />
                {tutorInfo.address?.city}, {tutorInfo.address?.country}
              </p>
            </div>
            {/* <div className="text-dark">
              <span>
                <span>Teaches: </span>
                {tutorInfo.interestAndPricing?.map((item, i) => (
                  [...new Set(item.subjects?.map(sub => sub.tag))]?.map((subject, k) => (
                    <span
                      key={k}
                      className="badge badge-light-primary"
                    >
                      {subject}
                    </span>
                  ))
                ))}
              </span>
            </div> */}
            <div className="py-1">
              <button
                className="btn btn-sm btn-primary py-0 px-2 mt-3 "
                onClick={(e) =>
                  handleStartConversationModal(e, props.modalInfo)
                }
              >
                Contact Student
              </button>
            </div>
          </div>
        </div>
      </div>
      {modal && (
        <ContactRequestModal photoIndex={photoIndex} setPhotoIndex={callback} />
      )}
    </div>
  );
}

export default ProfilePopup;
